module.exports = __webpack_public_path__ + "media/images/talent/intro-bottom-36d28abbf12e6390bf724ee412bd3b6f.png";